<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <hatadialog ref="hatadialog"></hatadialog>
    <genelfiltre ref="genelfiltre"></genelfiltre>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{ $t('Sales-Report') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-menu bottom left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list v-if="PB=='TRY'">
                  <v-list-tile @click="getListExcel()" >
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>

                <v-list v-if="PB=='TRY'">
                  <v-list-tile @click="ExcelSatisRaporuPNR()" >
                    <v-list-tile-title>{{this.$t('Excel-Sales-Report-PNR')}} </v-list-tile-title>
                  </v-list-tile>
                </v-list>

                
               

                <v-list>
                  <v-list-tile @click="DownloadSatisRaporuCariKod(0,'style')">
                    <v-list-tile-title>Html {{ $t('Download') }}  {{ $t('Group-by-Current-Code') }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>

                <v-list>
                  <v-list-tile @click="DownloadVizeSatisRaporuTakipNo(0,'style')">
                    <v-list-tile-title>Html {{ $t('Download') }} ( {{ $t('Visa-Sales-Report-According-Tracking-No') }} )</v-list-tile-title>
                  </v-list-tile>
                </v-list>

                <v-list v-if="PB=='TRY'">
                  <v-list-tile @click="DownloadVizeSatisRaporu(1,'style','')"  >
                    <v-list-tile-title>  {{ $t('Excel-Visa-Sales-Report') }} </v-list-tile-title>
                  </v-list-tile>
                </v-list>

                <v-list v-if="PB=='TRY'">
                  <v-list-tile @click="DownloadVizeSatisRaporu(1,'style','MALIYET')" >
                    <v-list-tile-title> {{ $t('Excel-Visa-Sales-Report-Costs') }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
                
                <v-list v-if="PB=='TRY'">
                  <v-list-tile @click="DownloadVizeSatisRaporu(1,'style','SATIS')" >
                    <v-list-tile-title> {{ $t('Excel-Visa-Sales-Report-Sales') }}  </v-list-tile-title>
                  </v-list-tile>
                </v-list>

                <v-list v-if="PB=='TRY'">
                  <v-list-tile @click="DownloadKomisyonRaporu(1,'style')">
                    <v-list-tile-title> {{ $t('Excel-Commission-Report') }} </v-list-tile-title>
                  </v-list-tile>
                </v-list>


                
                <v-list>
                  <v-list-tile @click="AcenteKomisyonRaporu()">
                    <v-list-tile-title>{{ $t('Agency-Commission-Report') }} </v-list-tile-title>
                  </v-list-tile>
                </v-list>
                <v-list>
                  <v-list-tile @click="AcenteKomisyonRaporuOzet()">
                    <v-list-tile-title>{{ $t('Agency-Commission-Report-Summary') }} </v-list-tile-title>
                  </v-list-tile>
                </v-list>
               
                
                <!--
                <v-list>
                  <v-list-tile @click="DownloadSatisRaporuCariKod(0,'styleSoft')">
                    <v-list-tile-title>Html İndir - Soft (Cari Koda Göre Grup)</v-list-tile-title>
                  </v-list-tile>
                </v-list>
                 
                <v-list>
                  <v-list-tile @click="DownloadSatisRaporuCariKod(1,'styleSoft')">
                    <v-list-tile-title>Excel indir - Soft ( {{ $t('Groups-Per-Current-Code') }} ) </v-list-tile-title>
                  </v-list-tile>
                </v-list>
                 -->

              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 pt-2 md2>
                        <v-select
                          :label="$t('Date-Type')"
                          items-value="value"
                          item-text="text"
                          :items="itemstarihtip"
                          v-model="tarihTip"
                        ></v-select>
                      </v-flex>

                      <v-flex xs12 sm6 pt-2 md2>
                        <tarihcomp
                          :etiket="$t('Starting-Date')"
                          :detaygizle="false"
                          :rules="[(v) => !!v || $t('Please-select-a-date')]"
                          v-bind:defaultvalue="'ok'"
                          v-bind:value="KayitTarihiBasla"
                          v-model="KayitTarihiBasla"
                        ></tarihcomp>
                      </v-flex>

                      <v-flex xs12 pt-2 sm6 md2>
                        <tarihcomp
                          :etiket="$t('Finishing-Date')"
                          :detaygizle="false"
                          :rules="[(v) => !!v || $t('Please-select-a-date')]"
                          v-bind:defaultvalue="'ok'"
                          v-bind:value="KayitTarihiBitis"
                          v-model="KayitTarihiBitis"
                        ></tarihcomp>
                      </v-flex>

                      <v-flex pt-2>
                        <v-layout row wrap align-center full-heigth>
                          <div v-if="load1">
                            <v-btn
                              color="info"
                              @click="getList()"
                              fab
                              small
                              dark
                            >
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="progress">
                            <v-layout align-center>
                              <v-progress-circular
                                indeterminate
                                :width="4"
                                color="blue"
                              ></v-progress-circular>
                            </v-layout>
                          </div>
                          <v-badge color="white" :overlap="true">
                            <template v-slot:badge>
                              <v-icon v-if="filtrevarmi" large color="green"
                                >check_circle_outline</v-icon
                              >
                            </template>

                            <v-btn
                              small
                              @mouseenter="tooltip = true"
                              @mouseleave="tooltip = false"
                              ref="fab"
                              @click="filtrele()"
                              color="info"
                              fab
                              dark
                            >
                              <v-icon>filter_list</v-icon>
                            </v-btn>
                            <v-tooltip bottom :activator="el" v-model="tooltip">
                              <span>{{$t('Add-Search-Filter')}}</span>
                            </v-tooltip>
                          </v-badge>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md12 pb-3>
                  <v-card flat class="white--text">
                    <v-card flat>
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12>
                            <v-card flat>
                              <v-data-table
                                :headers="headerssatis"
                                :rows-per-page-items="[20, 100]"
                                :items="itemssatis"
                                :search="searchsatilanbilet"
                              >
                                <template slot="items" slot-scope="props">
                                  <tr @click="git(props.item)" item>
                                    <td class="text-xs-left">
                                      {{ props.item.PNR_No }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.PNR_RezzKod }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.KayitTarihi | dateformat }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.PNR_CariKod }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.SatisTutar | moneyformat }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.AlisTutar | moneyformat }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{
                                        props.item.PKomisyonTutar | moneyformat
                                      }}
                                    </td>
                                    <td class="text-xs-right">
                                      {{ props.item.Odeme | moneyformat }}
                                    </td>
                                    <td class="text-xs-right">
                                      {{ props.item.Bakiye | moneyformat }}
                                    </td>
                                    <td class="text-xs-right">
                                      {{ props.item.KomisyonTL | moneyformat }}
                                    </td>
                                    <td class="text-xs-right">
                                      {{ props.item.PNR_Kar | moneyformat }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.CariUnvan }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.SirketNo }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.PNR_SatisTL | moneyformat }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.PNR_AlisTL | moneyformat }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{
                                        props.item.PNR_KomisyonTL | moneyformat
                                      }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.Donem1 | dateformat }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.Donem2 | dateformat }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.PNR_KarTL | moneyformat }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.SaticiCariUnvan }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.RezYapan }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.KisiIsimList }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.AnaTip }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.Acente }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.PNRUlke }}
                                    </td>
                                  </tr>
                                </template>
                                <v-alert
                                  slot="no-results"
                                  :value="true"
                                  color="error"
                                  icon="warning"
                                >
                                      {{ $t('No-records-searched-for', { value: searchsatilanbilet}) }} 
                                </v-alert>
                              </v-data-table>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
                <yetkidialog ref="yetkidialog"></yetkidialog>
              </v-layout>
            </v-form>
          </v-container>

          <v-snackbar
            :timeout="timeout"
            :top="y === 'top'"
            :bottom="y === 'bottom'"
            :right="x === 'right'"
            :left="x === 'left'"
            :multi-line="mode === 'multi-line'"
            :vertical="mode === 'vertical'"
            v-model="snackbar"
          >
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false"
              >{{$t('Close')}}</v-btn
            >
          </v-snackbar>

         
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
import auth from "../../../../api/auth";
import tarihcomp from "../../customcomp/tarihim";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import tool from "../../coper/tools";
import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
import anatip from "@/components/app/coper/comp/anatip.vue";
import rez from "../rezervasyon";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue";
import pnrbul from "@/components/app/coper/component/pnrbul.vue";
import cariaracomp from "@/components/app/customcomp/cariaracomp.vue";
import genelfiltre from "../comp/genelfiltre.vue";

export default {
  data() {
    return {
      PB:'TRY',
      itemstarihtip: genelfiltre.IslemTarihTip(),
      tarihTip: 0,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      filtrevarmi: false,
     
      searchsatilanbilet: null,

      headerssatis: [
        {
          text: "PNR",
          value: "PNR_No",
          width: "5%",
          align: "left",
        },
        {
          text: "PNR Rez Code",
          value: "PNR_RezzKod",
          width: "5%",
          align: "left",
        },
        {
          text: this.$t('Date'),
          value: "Kayit Tarihi",
          width: "5%",
          align: "left",
        },
        {
          text: this.$t('Currentcode_label'),
          value: "PNR_CariKod",
          width: "5%",
          align: "left",
        },
        {
          text: this.$t('Sales'),
          value: "SatisTutar",
          width: "5%",
          align: "left",
        },
        {
          text: this.$t('Buying'),
          value: "AlisTutar",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Commission'),
          value: "PKomisyonTutar",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Payment'),
          value: "Odeme",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Balance'),
          value: "Bakiye",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Commission'),
          value: "KomisyonTL",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Profit'),
          value: "PNR_Kar",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Title_label'),
          value: "CariUnvan",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Company-No'),
          value: "SirketNo",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Sales'),
          value: "PNR_SatisTL",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Buying')  ,
          value: "PNR_AlisTL",
          width: "10%",
          align: "left",
        },
        {
          text:  this.$t('Commission')  ,
          value: "PNR_KomisyonTL",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('First-Entry'),
          value: "Donem1",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Last-Departure'),
          value: "Donem2",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Profit') ,
          value: "PNR_KarTL",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Seller'),
          value: "SaticiCariUnvan",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Booker'),
          value: "RezYapan",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Name'),
          value: "KisiIsimList",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Main-Type'),
          value: "AnaTip",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Agency'),
          value: "Acente",
          width: "10%",
          align: "left",
        },
        {
          text: this.$t('Country_label'),
          value: "PNRUlke",
          width: "10%",
          align: "left",
        },
      ],

      Rapor: genelfiltre.EmptyPrametre(),

      KayitTarihiBasla: null,
      KayitTarihiBitis: null,
      valid: true,
      date: null,
      menu: false,
      modal: false,
      
      loading: false,
      items: [],
      load: false,
      load1: true,
     
      progress: false,
      tooltip: false,
      el: null,
    
      itemssatis: [],

      butondurum: true,
      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      text1: "",
      dictionary: {
        custom: {
          tarihsec: {
            required: () => this.$t('Please-select-a-date'),
          },
          tarihsec1: {
            required: () => this.$t('Please-select-a-date'),
          },
        },
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  beforeMount: beforeMount,

  mounted() {
    this.el = this.$refs.fab.$el;
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    var credentials = JSON.parse(
       window.localStorage.getItem("credentials")
    );
    this.PB=credentials.ParaBirimi;
    if (this.sayfayetki.Status == true) {
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            this.$validator.localize("en", this.dictionary);
            this.el = this.$refs.fab.$el;

            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              var url = "#/";
              window.open(url, "_self");
            }
          } else {
          }
        });
    }

  },

  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },

    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },

  components: {
    tarihcomp: tarihcomp,
    yetkidialog,
    hatadialog,
    anatip,
    genelarama,
    referansmerkezicomp,
    pnrbul,
    cariaracomp,
    genelfiltre,
  },
  watch: {},
  methods: {
    HataYonetimi(response, request, baslik) {
      if (response.status === 500) {
        //Internal Server Error
        this.$refs.hatadialog.open(response, request, baslik);
      } else {
        this.text1 = "Service Unavailable -" + baslik;
        this.snackbar = true;
      }
    },

    git(val) {
      var url = "#/coper/rezervasyon/index/id?islem=get&PNR_No=" + val.PNR_No;
      window.open(url, "_target");
    },
    getList: getList,
    getListExcel,
    ExcelSatisRaporuPNR,
    AcenteKomisyonRaporu,
    AcenteKomisyonRaporuOzet,
    
    DownloadSatisRaporuCariKod,
    DownloadVizeSatisRaporuTakipNo,
    DownloadVizeSatisRaporu,
    DownloadKomisyonRaporu,
    
    filtrele: filtrele,
   
  },
};

function filtrele() {
  //this.dialogfiltre = true;
  
  this.$refs.genelfiltre.open("").then((confirm) => {
        if (confirm.Status == true) {
          this.filtrevarmi = true;
          this.Rapor=confirm.Rapor;
          this.getList();
        } else {
          this.filtrevarmi = false;
          this.Rapor=confirm.Rapor;
        }
      });

}





function getList() {
  if (this.$refs.formgunluksatis.validate()) {
    var bastarih = new Date(this.KayitTarihiBasla);
    var bittarih = new Date(this.KayitTarihiBitis);

   
    if (bastarih <= bittarih) {
      this.progress = true;
      this.load1 = false;
   
      let params = {
        prm: genelfiltre.ParametreOlustur(genelfiltre.RaporTarihAyarla(this.Rapor,this.tarihTip, this.KayitTarihiBasla,this.KayitTarihiBitis)),
        tumSirketler: this.$refs.genelfiltre.TumSirketlerParametre(),
        sayfaAdi:this.$route.name
      };

      tool.http_post(this, "SatisRaporu", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.itemssatis = response.body.data;

            this.progress = false;
            this.load1 = true;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.progress = false;
            this.load1 = true;
          }
        },
        (response) => {
          this.HataYonetimi(response, params, "Satış Listesi Getirilemedi");
          this.progress = false;
          this.load1 = true;
        }
      );
    } else {
      this.text1 = this.$t('start-date-cannot-greater-than-end-date')
      this.snackbar = true;
    }
  }
}


function getListExcel() {
  if (this.$refs.formgunluksatis.validate()) {
    var bastarih = new Date(this.KayitTarihiBasla);
    var bittarih = new Date(this.KayitTarihiBitis);
  
 
    if (bastarih <= bittarih) {
      this.progress = true;
      this.load1 = false;

   
      let params = {
        prm: genelfiltre.ParametreOlustur(genelfiltre.RaporTarihAyarla(this.Rapor,this.tarihTip, this.KayitTarihiBasla,this.KayitTarihiBitis)),
        tumSirketler: this.$refs.genelfiltre.TumSirketlerParametre(),
        sayfaAdi:this.$route.name
      };

      tool.api_post_FileDownload(this, "Coper/ExcelSatisRaporu", params).then(
        (response) => {
          tool.CreateDownloadLink(response, "CoperSatisRaporu.xlsx");
          this.progress = false;
          this.load1 = true;
        },
        (response) => {
          this.HataYonetimi(response, params, "Satış Listesi Getirilemedi");
          this.progress = false;
          this.load1 = true;
        }
      );
    } else {
      this.text1 = this.$t('start-date-cannot-greater-than-end-date')
      this.snackbar = true;
    }
  }
}


function ExcelSatisRaporuPNR() {
  if (this.$refs.formgunluksatis.validate()) {
    var bastarih = new Date(this.KayitTarihiBasla);
    var bittarih = new Date(this.KayitTarihiBitis);
  
 
    if (bastarih <= bittarih) {
      this.progress = true;
      this.load1 = false;

   
      let params = {
        prm: genelfiltre.ParametreOlustur(genelfiltre.RaporTarihAyarla(this.Rapor,this.tarihTip, this.KayitTarihiBasla,this.KayitTarihiBitis)),
        tumSirketler: this.$refs.genelfiltre.TumSirketlerParametre(),
        sayfaAdi:this.$route.name
      };

      tool.api_post_FileDownload(this, "Coper/ExcelSatisRaporuPNR", params).then(
        (response) => {
          tool.CreateDownloadLink(response, "CoperSatisRaporuPNR.xlsx");
          this.progress = false;
          this.load1 = true;
        },
        (response) => {
          this.HataYonetimi(response, params, "Satış Listesi Getirilemedi");
          this.progress = false;
          this.load1 = true;
        }
      );
    } else {
      this.text1 = this.$t('start-date-cannot-greater-than-end-date')
      this.snackbar = true;
    }
  }
}


function AcenteKomisyonRaporu() {
  if (this.$refs.formgunluksatis.validate()) {
    var bastarih = new Date(this.KayitTarihiBasla);
    var bittarih = new Date(this.KayitTarihiBitis);
  
 
    if (bastarih <= bittarih) {
      this.progress = true;
      this.load1 = false;


      let prm = genelfiltre.ParametreOlustur(genelfiltre.RaporTarihAyarla(this.Rapor,this.tarihTip, this.KayitTarihiBasla,this.KayitTarihiBitis));
   
   
      let params = {
        
        tumSirketler: this.$refs.genelfiltre.TumSirketlerParametre(),
        sayfaAdi:this.$route.name
      };

      tool.api_post_FileDownload(this, "Coper/ExcelAcenteKomisyonRapor", params).then(
        (response) => {
          tool.CreateDownloadLink(response, "AcenteKomisyonRaporu.xlsx");
          this.progress = false;
          this.load1 = true;
        },
        (response) => {
          this.HataYonetimi(response, params, "Rapor Getirilemedi");
          this.progress = false;
          this.load1 = true;
        }
      );
    } else {
      this.text1 = this.$t('start-date-cannot-greater-than-end-date')
      this.snackbar = true;
    }
  }
}

function AcenteKomisyonRaporuOzet() {
  if (this.$refs.formgunluksatis.validate()) {
    var bastarih = new Date(this.KayitTarihiBasla);
    var bittarih = new Date(this.KayitTarihiBitis);
  
 
    if (bastarih <= bittarih) {
      this.progress = true;
      this.load1 = false;


      let prm = genelfiltre.ParametreOlustur(genelfiltre.RaporTarihAyarla(this.Rapor,this.tarihTip, this.KayitTarihiBasla,this.KayitTarihiBitis));
   
   
      let params = {
        
        tumSirketler: this.$refs.genelfiltre.TumSirketlerParametre(),
        sayfaAdi:this.$route.name
      };

      tool.api_post_FileDownload(this, "Coper/ExcelAcenteKomisyonRaporOzet", params).then(
        (response) => {
          tool.CreateDownloadLink(response, "AcenteKomisyonRaporuOzet.xlsx");
          this.progress = false;
          this.load1 = true;
        },
        (response) => {
          this.HataYonetimi(response, params, "Rapor Getirilemedi");
          this.progress = false;
          this.load1 = true;
        }
      );
    } else {
      this.text1 = this.$t('start-date-cannot-greater-than-end-date')
      this.snackbar = true;
    }
  }
}


function DownloadVizeSatisRaporuTakipNo(RaporTip,styleFile) {
  if (this.$refs.formgunluksatis.validate()) {
    var bastarih = new Date(this.KayitTarihiBasla);
    var bittarih = new Date(this.KayitTarihiBitis);

 
    if (bastarih <= bittarih) {
      this.progress = true;
      this.load1 = false;
 

      let params = {
        
          data:{
             Prm: genelfiltre.ParametreOlustur(genelfiltre.RaporTarihAyarla(this.Rapor,this.tarihTip, this.KayitTarihiBasla,this.KayitTarihiBitis))
          },
          raporTipi:RaporTip,
          styleFile:styleFile,
          tumSirketler: this.$refs.genelfiltre.TumSirketlerParametre(),
          sayfaAdi:this.$route.name
        
      };

      tool.api_post_FileDownload(this, "Coper/DownloadVizeSatisRaporuTakipNo", params).then(
        (response) => {
          
          if(RaporTip == 0)//html
          {
            
            tool.CreateDownloadLink(response, "VizeSatisRaporuTakipNo.html");
          }
          else if(RaporTip == 1)//excel
          {
            tool.CreateDownloadLink(response, "VizeSatisRaporuTakipNo.xls");
          }

          this.progress = false;
          this.load1 = true;
        },
        (response) => {
          this.HataYonetimi(response, params, "Satış Listesi Getirilemedi");
          this.progress = false;
          this.load1 = true;
        }
      );
    } else {
      this.text1 = this.$t('start-date-cannot-greater-than-end-date')
      this.snackbar = true;
    }
  }
}


function DownloadKomisyonRaporu(RaporTip,styleFile) {
  if (this.$refs.formgunluksatis.validate()) {
    var bastarih = new Date(this.KayitTarihiBasla);
    var bittarih = new Date(this.KayitTarihiBitis);

 
    if (bastarih <= bittarih) {
      this.progress = true;
      this.load1 = false;

     

      let params = {
        
          data:{
             Prm: genelfiltre.ParametreOlustur(genelfiltre.RaporTarihAyarla(this.Rapor,this.tarihTip, this.KayitTarihiBasla,this.KayitTarihiBitis))
          },
          raporTipi:RaporTip,
          styleFile:styleFile,
          tumSirketler: this.$refs.genelfiltre.TumSirketlerParametre(),
          sayfaAdi:this.$route.name
        
      };

      tool.api_post_FileDownload(this, "Coper/DownloadKomisyonRaporu", params).then(
        (response) => {
          
          if(RaporTip == 0)//html
          {
            tool.CreateDownloadLink(response, "KomisyonRaporu.html");
          }
          else if(RaporTip == 1)//excel
          {
            tool.CreateDownloadLink(response, "KomisyonRaporu.xls");
          }

          this.progress = false;
          this.load1 = true;
        },
        (response) => {
          this.HataYonetimi(response, params, "Satış Listesi Getirilemedi");
          this.progress = false;
          this.load1 = true;
        }
      );
    } else {
      this.text1 = this.$t('start-date-cannot-greater-than-end-date')
      this.snackbar = true;
    }
  }
}


function DownloadVizeSatisRaporu(RaporTip,styleFile,sablonAdi) {
  if (this.$refs.formgunluksatis.validate()) {
    var bastarih = new Date(this.KayitTarihiBasla);
    var bittarih = new Date(this.KayitTarihiBitis);

      if (bastarih <= bittarih) {
      this.progress = true;
      this.load1 = false;

   

      let params = {
        
          data:{
             Prm: genelfiltre.ParametreOlustur(genelfiltre.RaporTarihAyarla(this.Rapor,this.tarihTip, this.KayitTarihiBasla,this.KayitTarihiBitis))
          },
          raporTipi:RaporTip,
          styleFile:styleFile,
          sablonAdi:sablonAdi,
          tumSirketler: this.$refs.genelfiltre.TumSirketlerParametre(),
          sayfaAdi:this.$route.name
        
      };

      tool.api_post_FileDownload(this, "Coper/DownloadVizeSatisRaporu", params).then(
        (response) => {
          
          if(RaporTip == 0)//html
          {
            tool.CreateDownloadLink(response, "VizeSatisRaporu.html");
          }
          else if(RaporTip == 1)//excel
          {
            tool.CreateDownloadLink(response, "VizeSatisRaporu.xls");
          }

          this.progress = false;
          this.load1 = true;
        },
        (response) => {
          this.HataYonetimi(response, params, "Satış Listesi Getirilemedi");
          this.progress = false;
          this.load1 = true;
        }
      );
    } else {
      this.text1 = this.$t('start-date-cannot-greater-than-end-date')
      this.snackbar = true;
    }
  }
}


function DownloadSatisRaporuCariKod(RaporTip,styleFile) {

  var lang = localStorage.getItem('lang')
  if (this.$refs.formgunluksatis.validate()) {
    var bastarih = new Date(this.KayitTarihiBasla);
    var bittarih = new Date(this.KayitTarihiBitis);

 
    if (bastarih <= bittarih) {
      this.progress = true;
      this.load1 = false;


      let params = {
        
          data:{
             Prm: genelfiltre.ParametreOlustur(genelfiltre.RaporTarihAyarla(this.Rapor,this.tarihTip, this.KayitTarihiBasla,this.KayitTarihiBitis))
          },
          tumSirketler: this.$refs.genelfiltre.TumSirketlerParametre(),
          sayfaAdi:this.$route.name,
          raporTipi:RaporTip,
          styleFile:styleFile
        
      };

      tool.api_post_FileDownload(this, "Coper/DownloadSatisRaporuCariKod", params).then(
        (response) => {
          
          if(RaporTip == 0)//html
          {
         
            tool.CreateDownloadLink(response, "CoperSatisRaporu.html");
          }
          else if(RaporTip == 1)//excel
          {
            tool.CreateDownloadLink(response, "CoperSatisRaporu.xls");
          }

          this.progress = false;
          this.load1 = true;
        },
        (response) => {
          this.HataYonetimi(response, params, "Satış Listesi Getirilemedi");
          this.progress = false;
          this.load1 = true;
        }
      );
    } else {
      this.text1 = this.$t('start-date-cannot-greater-than-end-date')
      this.snackbar = true;
    }
  }
}


function beforeMount() {}
</script>
<style>
</style>